import { render, staticRenderFns } from "./ArchiveNew.vue?vue&type=template&id=138d78d4&"
import script from "./ArchiveNew.vue?vue&type=script&lang=js&"
export * from "./ArchiveNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports